var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-none habiteo-body-2 mx-2 text-btn",class:{
        'small-btn': _vm.isSmall,
        'medium-btn': _vm.isMedium
    },attrs:{"outlined":"","ripple":false},on:{"click":function($event){$event.preventDefault();return _vm.manageClick.apply(null, arguments)}}},[_c('span',[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45cacbbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchPopup/components/TextButton.vue
// module id = null
// module chunks = 